<template>
  <div class="container">
    <div class="task-box bg-white">
      <h2>待处理</h2>
      <div class="f fw-w">
        <div
          class="matter-item f-b-c pointer"
          v-for="(item, index) in allUpcomingMatter"
          :key="index"
          @click="handleClick(item)"
        >
          <div>
            <div class="type">{{ item.type }}</div>
            <div class="count">{{ item.count }}</div>
          </div>
          <i
            v-if="item.type === '认证审核'"
            class="iconfont icon-anquanrenzheng"
            style="font-size: 40px"
          ></i>
          <i
            v-if="item.type === '退款审核'"
            class="iconfont icon-tuikuan"
            style="font-size: 40px"
          ></i>
          <i
            v-if="item.type === '取消交运审核'"
            class="el-icon-document-delete"
            style="font-size: 40px"
          ></i>
        </div>
      </div>
    </div>
    <!-- <div class="title f">
            <span>仪表盘</span>
            <span>时区(UTC+08:00) 北京时间 {{ nowTime }}</span>
        </div> -->
    <!-- 初始化时会默认调用，时间为七天内 -->
    <div class="bg-white" style="padding: 16px 20px 20px 20px">
      <h2>数据分析</h2>
      <timeSelect @timeChange="timeChange"></timeSelect>
      <div class="charts">
        <registerVisitorCharts
          ref="registerVisitorCharts"
        ></registerVisitorCharts>
      </div>
      
      <div class="ranking_group f-b">
        <ranking-module :rankingData="bannerRanking" @lookInfo="lookInfo" style="width:32%">
        </ranking-module>
        <ranking-module :rankingData="categoryRanking" @lookInfo="lookInfo" style="width:32%">
        </ranking-module>
        <ranking-module :rankingData="activityRanking" @lookInfo="lookInfo" style="width:32%">
        </ranking-module>
      </div>
      <div class="ranking_group f-b">
        <ranking-module :rankingData="productRanking" style="width:49%">
        </ranking-module>
        <ranking-module :rankingData="likeRanking" @lookInfo="lookInfo" style="width:49%">
        </ranking-module>
      </div>
      <div class="ranking_group f-b">
        <ranking-module :rankingData="pageRanking" style="width:49%">
        </ranking-module>
        <ranking-module :rankingData="sourceRanking" @lookInfo="lookInfo" style="width:49%">
        </ranking-module>
      </div>
      <div class="ranking_group f-b">
        <ranking-module :rankingData="countryRanking" @lookInfo="lookInfo" style="width:49%">
        </ranking-module>
      </div>
    </div>


    <visitor ref="visitor"></visitor>
  </div>
</template>

<script>
import registerVisitorCharts from "./components/registerVisitorCharts.vue";
import ranking from "./components/ranking.vue";
import API from "@/api";
import moment from "moment";
import visitor from "./components/visitor.vue";
import funnel from "./components/funnel.vue";
import timeSelect from "./components/timeSelect.vue";
import RankingModule from './components/rankingModule.vue';

export default {
  name: 'dashboard',
  components: {
    registerVisitorCharts,
    ranking,
    visitor,
    funnel,
    timeSelect,
    RankingModule,
  },
  data() {
    return {
      nowTime: 0,
      chartTime: [moment().subtract("days", 6), moment()],
      allUpcomingMatter: [],

      bannerRanking: null,
      categoryRanking: null,
      activityRanking: null,
      productRanking: null,
      likeRanking: null,
      pageRanking: null,
      sourceRanking: null,
      countryRanking: null,
    };
  },
  provide() {
    return {
      chartTime: this.chartTime,
    };
  },
  created() {
    this.getAllUpcomingMatter();
  },
  mounted() {
    this.nowTime = moment().format("YYYY-MM-DD HH:mm:ss");
  },
  activated() {
    this.getAllUpcomingMatter();
  },
  methods: {
    // 待处理
    getAllUpcomingMatter() {
      API.getAllUpcomingMatter({}).then((res) => {
        this.allUpcomingMatter = res.data;
      });
    },
    // 统计数据
    getDashboard(params) {
      API.getDashboard(params).then(res => {
        this.bannerRanking = {
          title: '首页Banner图排行',
          type: 'banner',
          is_detail: true,
          open_detail: true,
          chartTime: this.chartTime,
          tableData: res.data.banner
        }
        this.categoryRanking = {
          title: '首页分类排行',
          type: 'category',
          is_detail: true,
          open_detail: true,
          chartTime: this.chartTime,
          tableData: res.data.category
        }
        this.activityRanking = {
          title: '首页活动排行',
          type: 'activity',
          is_detail: true,
          open_detail: true,
          chartTime: this.chartTime,
          tableData: res.data.activity
        }
        this.productRanking = {
          title: '商品浏览排行',
          type: 'product',
          is_detail: true,
          path: `/statistics/product-statistics`,
          chartTime: this.chartTime,
          tableData: res.data.product
        }
        this.likeRanking = {
          title: '首页猜你喜欢浏览排行',
          type: 'product_like',
          is_detail: true,
          open_detail: true,
          chartTime: this.chartTime,
          tableData: res.data.recommend
        }
      })


      API.dashboardSalesSort(params).then((res) => {
        this.sourceRanking = {
          title: '搜索来源访客',
          type: 'visitor',
          is_detail: true,
          open_detail: true,
          chartTime: this.chartTime,
          tableData: res.data.source
        }
        this.countryRanking = {
          title: '按国家分类访客',
          type: 'visitor1',
          is_detail: true,
          open_detail: true,
          chartTime: this.chartTime,
          tableData: res.data.countrySort
        }
      })
      
      API.dashboardPage({ 
        ...params,
        pageNumber: 1,
        pageSize: 10
      }).then(res => {
        this.pageRanking = {
          title: '页面路径排行',
          type: 'page',
          is_detail: true,
          path: `/report/pageStatistics`,
          chartTime: this.chartTime,
          tableData: res.data.list
        }
      })

    },

    getData(params) {
      this.dashboardLineChart(params);
      this.getDashboard(params)
    },
    // 折线图
    dashboardLineChart(params) {
      API.dashboardLineChart(params)
        .then((res) => {
          const { dataList, ...topNum } = res.data;
          this.$refs.registerVisitorCharts.setTopNum(topNum);
          this.$refs.registerVisitorCharts.drawChart(dataList);
        })
        .catch(() => {});
    },
    // 切换日期
    timeChange(value) {
      const params = {
        startTime: parseInt(
          value[0].format("YYYY-MM-DD").split("-").join("")
        ),
        endTime: parseInt(value[1].format("YYYY-MM-DD").split("-").join("")),
      };
      this.chartTime = value;
      this.getData(params);
    },
    handleClick(item) {
      switch (item.type) {
        case "认证审核":
          this.$router.push({
            path: "/customer/management",
            query: { type: 1 },
          });
          break;
        case "退款审核":
          this.$router.push({
            path: "/after-sale/after-sale",
            query: {
              status: 1,
            },
          });
          break;
        case "取消交运审核":
          this.$router.push({
            path: "/orders/all-orders",
            query: {
              searchArray: item.kkOrderIds,
            },
          });
          break;
        default:
          break;
      }
    },
    lookInfo(e) {
      this.$refs.visitor.showTable(e)
    },
  },
};
</script>

<style lang="scss">
.container {
  min-width: 1200px;
  padding-bottom: 40px;
  .form {
    margin-bottom: 10px;
  }
  .title {
    height: 20px;
    line-height: 20px;
    margin: 20px;
    > span:first-of-type {
      font-size: 20px;
      font-weight: bold;
      margin-right: 8px;
    }
    > span:nth-of-type(2) {
      font-size: 12px;
    }
  }
  .ranking_group {
    margin-bottom: 20px;
    >div {
      box-shadow: 5px 5px 5px #ebeef5;
      border: 1px solid #ebeef5;
    }
  }
}
h2 {
  font-weight: 500;
  font-size: 20px;
  line-height: 30px;
  color: #111827;
  padding-bottom: 12px;
}
.task-box {
  margin-bottom: 10px;
  padding: 16px 20px 0 20px;
  .matter-item {
    width: 350px;
    height: 90px;
    background: #ffffff;
    border: 1px solid #e5e6eb;
    box-shadow: 0px 4px 14px 6px rgba(205, 212, 221, 0.1);
    border-radius: 6px;
    margin-right: 30px;
    margin-bottom: 20px;
    padding: 22px 30px;
  }
  .type {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #747a87;
    margin-bottom: 5px;
  }
  .count {
    font-weight: 500;
    font-size: 20px;
    line-height: 30px;
    color: #000000;
  }
  img {
    width: 32px;
    height: 37px;
  }
}
</style>